import './host.css';

import { SERVER_VERSION, canLogin } from '../config';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ClinicLogo from '../Practice/Logo';
import Grid from '@mui/material/Grid2';
import Logo from '../Observodon/components/Logo/Logo';
import ObservodonStationery from '../Observodon/components/Stationery/ObservodonStationery';
import { PracticeRoutes } from '../common/PracticeRoutes';
import React from 'react';
import TopMenu from '../shared/TopMenu';
import Typography from '@mui/material/Typography';
import useServerConfig from '../hooks/useServerConfig';

/** URL to marketing site. */
const OBSERVODON_MARKETING_URL = 'https://observodon.cloud';

/**
 * Simple component that displays *Home*. This is suitable for demonstrating
 * a simple non-logged-in view.
 */
const Home = () => {
  const { config } = useServerConfig();
  return (
    <>
      <ObservodonStationery
        menu={<TopMenu />}
        style={{ height: 'calc(100% - 16px)' }}
      >
        <Typography
          variant="caption"
          style={{ position: 'absolute', right: 16, bottom: 8, opacity: 0.5 }}
        >
          {SERVER_VERSION} {config?.COMMIT_SHA}
        </Typography>
        <Grid
          container
          direction="column"
          justifyContent="space-between"
          style={{ height: 'calc(100% - 2em' }}
        >
          <Grid></Grid>

          <Grid>
            <Box alignContent="center">
              <a href={OBSERVODON_MARKETING_URL}>
                <Logo
                  style={{ display: 'block', width: '80%', margin: '0 10%' }}
                />
              </a>
            </Box>
            <p></p>
            <Typography>
              <p>
                <a href={OBSERVODON_MARKETING_URL}>Observodon</a> is a powerful
                video observation platform designed to enhance learning through
                interactive video engagement. Students can upload their own
                videos or work with tutor-provided footage, using built-in tools
                to pause, annotate, take screenshots, and leave time-stamped
                comments. These features make it ideal for coaching, feedback,
                and skill development across a wide range of subjects.
              </p>
              <p>
                Seamlessly integrating with Moodle, Blackboard, Canvas, and
                other leading LMS platforms, Observodon brings advanced video
                interaction to modern education. It helps educators boost
                engagement, deliver more effective feedback, and empower
                students to reflect and improve—making video a truly dynamic
                part of the learning experience.
              </p>
            </Typography>
            <p></p>
          </Grid>
          <Grid>
            {/* {canLogin && (
              <Box alignContent="center" style={{ textAlign: 'center' }}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  href={PracticeRoutes.HOME}
                >
                  <Grid container direction="column" alignItems="center">
                    <ClinicLogo
                      size={32}
                      style={{
                        background: 'white',
                        padding: 4,
                        borderRadius: 4
                      }}
                    />
                    <>Launch demo</>
                  </Grid>
                </Button>
              </Box>
            )} */}
          </Grid>
        </Grid>
      </ObservodonStationery>
    </>
  );
};
export default Home;
